const PluginManager = window.PluginManager;

PluginManager.register('COBDiscountRequest', () => import('./plugins/discount-request.plugin'));
PluginManager.register('COBMixedPlugin', () => import('./plugins/mixed.plugin'));
PluginManager.register('COBListingPlugin', () => import('./plugins/listing-sort.plugin'));
